module.exports = __webpack_public_path__ + "static/media/618.ce11671f.webp";